var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14460_91896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.332 4H2.66536C2.31174 4 1.9726 4.14048 1.72256 4.39052C1.47251 4.64057 1.33203 4.97971 1.33203 5.33333V18.6667C1.33203 19.0203 1.47251 19.3594 1.72256 19.6095C1.9726 19.8595 2.31174 20 2.66536 20H21.332C21.6857 20 22.0248 19.8595 22.2748 19.6095C22.5249 19.3594 22.6654 19.0203 22.6654 18.6667V5.33333C22.6654 4.97971 22.5249 4.64057 22.2748 4.39052C22.0248 4.14048 21.6857 4 21.332 4ZM20.3054 18.6667H3.77203L8.4387 13.84L7.4787 12.9133L2.66536 17.8933V6.34667L10.952 14.5933C11.2018 14.8417 11.5398 14.9811 11.892 14.9811C12.2443 14.9811 12.5822 14.8417 12.832 14.5933L21.332 6.14V17.8067L16.4254 12.9L15.4854 13.84L20.3054 18.6667ZM3.5387 5.33333H20.252L11.892 13.6467L3.5387 5.33333Z",
    fill: "#23242F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14460_91896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7d5f0930d40153a6afe1eca8e3bf2040.svg";
export { ForwardRef as ReactComponent };